import React from 'react';
import classNames from 'classnames';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import {
  AlertColor,
  Alert as AlertComponent,
  AlertTitle,
  AlertProps as MuiAlertProps,
} from '@mui/material';
import layoutStyles from '../../../stylesheets/components/layout.module.scss';
import alertStyles from '../../../stylesheets/components/alert.module.scss';
import { AlertTriangleIcon } from './shared_icons/AppIcons';

interface AlertInterface {
  id?: string;
  className?: string;
  dataTestClass?: string;
  onClose?: MuiAlertProps['onClose'];
  severity: AlertColor;
  title?: React.ReactNode;
  children: React.ReactNode;
}

const iconMapping = {
  error: <AlertTriangleIcon />,
  info: <InfoOutlinedIcon fontSize="inherit" />,
  success: <CheckCircleOutlineIcon fontSize="inherit" />,
  warning: <ReportProblemOutlinedIcon fontSize="inherit" />,
};

const Alert = ({
  id,
  className,
  dataTestClass,
  onClose,
  severity,
  title,
  children,
}: AlertInterface) => {
  return (
    <AlertComponent
      className={classNames(layoutStyles.mb12, alertStyles.alert, className)}
      data-test-class={dataTestClass}
      iconMapping={iconMapping}
      id={id}
      onClose={onClose}
      severity={severity}
    >
      {title && (
        <AlertTitle className={alertStyles.alertTitle}>{title}</AlertTitle>
      )}
      {children}
    </AlertComponent>
  );
};

export default Alert;
